import { REHYDRATE, TOGGLE_SIDEBAR } from "@Actions/types";

export default function reducer(state = { isExtended: false }, action) {
	const { type, payload } = action;
	switch (type) {
		case REHYDRATE:
			return { ...state, isExtended: payload.data.menu.isExtended };

		case TOGGLE_SIDEBAR:
			return { ...state, isExtended: !state.isExtended };

		default:
			return state;
	}
}
